import { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import API_URL from '../config'

function SignUp() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Check if passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }

    try {
      await axios.post(`${API_URL}signup/`, { username, password, email })
      navigate('/login')
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred during signup')
    }
  }

  return (
    <div className='bg-contextWhite'>
      <div className='container flex flex-col items-center justify-center'>
        <div className='mx-auto w-full max-w-md p-6'>
          {error && <p className='text-red-500 mb-4 text-center'>{error}</p>}

          <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
            <div className='flex flex-row items-center'>
              <label htmlFor='username' className='w-24 text-sm'>
                username
              </label>
              <input
                type='text'
                id='username'
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className='border-gray-300 bg-white focus:border-black flex-1 rounded border p-2 focus:outline-none'
              />
            </div>

            <div className='flex flex-row items-center'>
              <label htmlFor='email' className='w-24 text-sm'>
                email
              </label>
              <input
                type='email'
                id='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className='border-gray-300 bg-white focus:border-black flex-1 rounded border p-2 focus:outline-none'
              />
            </div>

            <div className='flex flex-row items-center'>
              <label htmlFor='password' className='w-24 text-sm'>
                password
              </label>
              <input
                type='password'
                id='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className='border-gray-300 bg-white focus:border-black flex-1 rounded border p-2 focus:outline-none'
              />
            </div>

            <div className='flex flex-row items-center'>
              <label htmlFor='confirmPassword' className='w-24 text-sm'>
                confirm
              </label>
              <input
                type='password'
                id='confirmPassword'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className='border-gray-300 bg-white focus:border-black flex-1 rounded border p-2 focus:outline-none'
              />
            </div>

            <button type='submit' className='context-button mt-2 self-center'>
              Sign Up
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SignUp
